import { IntentResource } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";

import { showIntentProjectResourceDetailsDrawer } from "../../Details";

const IntentProjectResourcesTableRowActionsCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<IntentResource>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Resource actions">
        <DropdownMenuItem onAction={() => showIntentProjectResourceDetailsDrawer({ resource })}>
          See details
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default IntentProjectResourcesTableRowActionsCell;
